import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEllipsisV } from '@fortawesome/pro-solid-svg-icons/faEllipsisV'
import { Button, Menu, Dropdown, Tooltip } from 'antd'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router'
import { IRole } from 'interfaces/roles'
import { PathRoutes } from 'enum/routes'
import { Wrapper } from './styled'

interface IProps {
  role: IRole
  confirmDeletion: (role: IRole) => void
}

export const Options = ({ role, confirmDeletion }: IProps) => {
  const { t } = useTranslation()
  const history = useHistory()
  const prefix = 'configuration.rolesAndPermissions.roles.table.actions'

  const edit = () => {
    history.push(
      PathRoutes.ROLES_AND_PERMISSIONS_ROLES_EDIT.replace(
        ':id',
        role.id.toString()
      )
    )
  }

  const deleteLabel = t(`${prefix}.delete.title`)
  const deleteItem = role.isDefault ? (
    <Tooltip
      getPopupContainer={() =>
        document.getElementById('lmsPage') as HTMLElement
      }
      title={
        <div style={{ width: '200px' }}>
          {t(`${prefix}.delete.disabledTooltip`)}
        </div>
      }
    >
      <span>{deleteLabel}</span>
    </Tooltip>
  ) : (
    deleteLabel
  )

  return (
    <Dropdown
      placement="bottomRight"
      overlay={
        <Menu>
          <Menu.Item onClick={edit}>{t(`${prefix}.edit`)}</Menu.Item>
          <Menu.Item
            disabled={role.isDefault}
            onClick={() => !role.isDefault && confirmDeletion(role)}
          >
            {deleteItem}
          </Menu.Item>
        </Menu>
      }
    >
      <Wrapper>
        <Button type="link">
          <FontAwesomeIcon icon={faEllipsisV} />
        </Button>
      </Wrapper>
    </Dropdown>
  )
}

export default Options
